import { render, staticRenderFns } from "./print_record.vue?vue&type=template&id=515e1357&scoped=true&"
import script from "./print_record.vue?vue&type=script&lang=js&"
export * from "./print_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e1357",
  null
  
)

export default component.exports